<template>
	<div v-if="toValueDisplay != null" class="wrapper">
		<div v-if="fromValueDisplay == null">
			{{ $t('common.emptyValue') }}
		</div>
		<div v-else>{{ fromValueDisplay }}</div>
		<div>&darr;</div>
		<div>{{ toValueDisplay }}</div>
	</div>
</template>

<script>
import { toRef, computed } from 'vue';

import Utils from '@/api/Utils';

const getValueDisplay = valueRef => computed(() => {
	if (valueRef.value == null) {
		return null;
	}
	return Utils.formatMetres(Utils.mm2m(valueRef.value));
});

export default {
	props: ['fromValue', 'toValue'],
	setup(props) {
		const fromValueRef = toRef(props, 'fromValue');
		const toValueRef = toRef(props, 'toValue');
		return {
			fromValueDisplay: getValueDisplay(fromValueRef),
			toValueDisplay: getValueDisplay(toValueRef),
		};
	},
}
</script>

<style scoped>
.wrapper {
	width: 100%;
	text-align: center;
}

.wrapper div {
	margin: 0 auto;
}
</style>
